import React from 'react';

import FolderSelector from 'file-browser/FolderSelector';

interface FolderEditorProps {
  value: string | null;
  onChange: (folderId: string | null) => void;
  required: boolean;
  disabled?: boolean;
}

export default function FolderEditor({value, onChange, required, disabled}: FolderEditorProps): JSX.Element {
  return (
    <FolderSelector
      value={value}
      allowNone={!required}
      showRegistries={true}
      enableRedesign={true}
      level="append"
      error=""
      readOnly={Boolean(disabled)}
      requireSubfolderCreatableAuth={false}
      showInventory={true}
      showNotebook={false}
      unsetOnFetchFail={false}
      checkExistingItemForDataModsMovement={false}
      noFolderText={required ? 'Choose folder' : 'Leave folder unchanged'}
      onChange={(e) => {
        // Normalize empty string to null (empty string is unset per RegistryUtil.parseFolderValue).
        onChange(e.target.value || null);
      }}
    />
  );
}
